
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TicketsModule } from '@/store/modules/tickets'
import detailContent from '@/views/orderDetail/detailContent.vue'
import { isItTicketType } from '@/utils/commonFunc'

@Component({
  name: 'DetailDialog',
  components: {
    detailContent
  }
})
export default class extends Vue {
  @Prop({ default: false }) private isManager!: boolean // 是否为保障人员(处理)权限

  get dialogVisible() {
    return TicketsModule.detailDialog
  }

  get isItTicketType() {
    return isItTicketType()
  }

  @Watch('dialogVisible')
  private onDialogStatusChange(value: boolean) {
    if (value) { // 打开弹框
    }
  }

  // 事件节点组件更新数据，也在父组件中详情更新后调用
  private handleEvents() {
    this.$refs.detailContent && (this.$refs.detailContent as any).handleEvents()
  }

  private handleSuccess(res: any) {
    if (res.stat) {
      this.$emit('handleSuccess', res)
    }
  }

  // 关闭弹框
  private handleClose() {
    TicketsModule.ToggleDialogStatus({
      name: 'detailDialog',
      value: false
    })
  }
}
